import React from 'react';
// components
import { Form, Field } from 'react-final-form';
import { Link } from 'react-router-dom';
// actions
import { composeValidators, noop, getNumericChars } from '../../utils/helper';
import { isMobile, required, isName, email } from '../../utils/validation';
import sessionStorageHelper from '../../utils/sessionStorageHelper';

// Style
import './CampaignForm.scss';

const onChangePhone = (event, input, checkUserExists) => {
  const val = event.target.value;
  input.onChange(getNumericChars(val));
  if (val.length === 10) {
    checkUserExists(val);
  }
};

const Radio = ({ input, children }) => {
  return (
    <div className="mr-r25 margin-r25">
      <input id={children} type="radio" {...input} />
      <label className="pd-l30 padding-l30 fsp16 fs16" htmlFor={children}>
        {children}
      </label>
    </div>
  );
};

const alreadyUserExists = () => {
  sessionStorageHelper.setItem('userFromOffer', true);
};

function CampaignForm(props) {
  const {
    login,
    saveUserDataLoading,
    checkUserExists,
    dataLocale: { CONTINUE, FEMALE, MALE, NAME, SIGN_IN, PHONE_NUMBER, EMAIL_ID },
    isUserExists,
    submitOfferForm,
    persistFormValue,
    formConfig = {},
  } = props;
  const { name, mobileNumber, email: userEmail, gender } = persistFormValue || {};
  const {
    emailMandatory,
    genderMandatory,
    nameMandatory,
    phoneMandatory,
    showEmail,
    showGender,
    showName,
    showPhone,
    alreadyAccountText,
  } = formConfig;
  const getUserFormData = values => {
    submitOfferForm(values);
  };

  return (
    <Form
      initialValues={{ name, mobileNumber, email: userEmail, gender }}
      onSubmit={getUserFormData}
    >
      {({ handleSubmit, valid }) => {
        return (
          <form autoComplete="off" className="campaign-form pd-20" onSubmit={handleSubmit}>
            {showName && (
              <Field
                name="name"
                validate={nameMandatory ? composeValidators(required, isName) : isName}
              >
                {({ input, meta }) => (
                  <div className="form-group pos-rel mr-b15">
                    <input
                      {...input}
                      autoComplete="off"
                      className="form-input"
                      maxLength="50"
                      type="text"
                    />
                    <label className="fsp14">
                      <span>{NAME}</span>
                    </label>
                    <span className="block margin-t4 fs12 mr-t4 fsp12 text-color_brick_red">
                      {meta.error && meta.touched ? meta.error : ''}
                    </span>
                  </div>
                )}
              </Field>
            )}

            {showGender && (
              <div className="radio-group margin-t25 mr-t25 margin-b10 mr-b15">
                <div className="display-flex">
                  <Field
                    component={Radio}
                    name="gender"
                    type="radio"
                    validate={genderMandatory ? required : noop}
                    value="male"
                  >
                    {MALE}
                  </Field>
                  <Field
                    component={Radio}
                    name="gender"
                    type="radio"
                    validate={genderMandatory ? required : noop}
                    value="female"
                  >
                    {FEMALE}
                  </Field>
                </div>
                {genderMandatory && (
                  <Field name="gender">
                    {({ meta }) => (
                      <span className="block margin-t4 fs12 mr-t4 fsp12 text-color_brick_red">
                        {meta.error && meta.touched ? meta.error : ''}
                      </span>
                    )}
                  </Field>
                )}
              </div>
            )}

            {showEmail && (
              <Field
                name="email"
                validate={emailMandatory ? composeValidators(required, email) : email}
              >
                {({ input, meta }) => (
                  <div className="form-group pos-rel mr-b15">
                    <input {...input} autoComplete="off" className="form-input" type="text" />
                    <label>
                      <span className="text-capitalize">
                        {EMAIL_ID}
                        {emailMandatory && <sup>*</sup>}
                      </span>
                    </label>
                    {meta.error && meta.touched && (
                      <span className="block margin-t4 fs12 mr-t4 fsp12 text-color_brick_red">
                        {meta.error}
                      </span>
                    )}
                  </div>
                )}
              </Field>
            )}

            {showPhone && !login && (
              <Field
                name="mobileNumber"
                validate={phoneMandatory ? composeValidators(required, isMobile) : isMobile}
              >
                {({ input, meta }) => {
                  return (
                    <div className="mr-b15 display-flex form-group">
                      <div className="country-code mr-r12">
                        <span className="form-input inline-block display-center">+91</span>
                      </div>
                      <div className="flex-1">
                        <div className="pos-rel">
                          <input
                            className="form-input"
                            {...input}
                            autoComplete="off"
                            maxLength="10"
                            type="tel"
                            onChange={e => onChangePhone(e, input, checkUserExists)}
                          />
                          <label className="text-capitalize">
                            <span>
                              {PHONE_NUMBER}
                              {phoneMandatory && <sup>*</sup>}
                            </span>
                          </label>
                        </div>
                        <span className="block margin-t4 fs12 mr-t4 fsp12 text-color_brick_red">
                          {meta.error && meta.touched ? meta.error : ''}
                        </span>
                      </div>
                    </div>
                  );
                }}
              </Field>
            )}
            {isUserExists && (
              <div className="user-exists-container mr-b15">
                <div className="display-flex justify-space-between align-items-center pd-t12 pd-b12 pd-r15 pd-l15 bora-4">
                  <div className="fsp15 flex-basis-64 lh-22 text-cool_grey">
                    {alreadyAccountText}
                  </div>
                  <Link
                    className="fsp14 text-topaz text-uppercase fw500"
                    to="/customer/account/login"
                    onClick={() => alreadyUserExists()}
                  >
                    {SIGN_IN}
                  </Link>
                </div>
              </div>
            )}

            <div className="btn-container">
              <button
                className="form-submit fsp18 fs18 fw500 text-uppercase bora-4"
                disabled={!valid || isUserExists}
                type="submit"
              >
                {saveUserDataLoading ? (
                  <span className="pd-t10 pd-b10 block icon-spinner animate-spin"></span>
                ) : (
                  CONTINUE
                )}
              </button>
            </div>
          </form>
        );
      }}
    </Form>
  );
}

export default CampaignForm;
